export enum ASPECT_RATIOS {
  square = 1,
  rectangle = 4 / 3,
  wideRectangle = 16 / 9,
  none = 0
}

export enum AspectRatioOptions {
  Square = '1:1',
  FourThree = '4:3',
  SixteenNine = '16:9'
}

export const IMAGE_COMPRESSION = {
  quality: 0.7
};

export interface ImageCropperOptions {
  imageChangedEvent: any;
  name: string;
  outputHeight: number;
  outputWidth: number;
  file?: File;
  aspectRatio: number;
  roundCropper: boolean;
  maintainAspectRatio: boolean;
  showAspectRatio: boolean;
  showAspectRatioSelection: boolean;
  containWithinAspectRatio: boolean;
}

export type ImageCropperInput = Partial<Omit<ImageCropperOptions, 'imageChangedEvent' | 'name'>> & Pick<ImageCropperOptions, 'imageChangedEvent' | 'name'>;

export class ImageCropperModel {
  private static readonly DEFAULTS: Omit<ImageCropperOptions, 'imageChangedEvent' | 'name' | 'outputWidth'> = {
    outputHeight: 800,
    aspectRatio: ASPECT_RATIOS.square,
    roundCropper: false,
    maintainAspectRatio: true,
    showAspectRatio: false,
    showAspectRatioSelection: false,
    containWithinAspectRatio: false
  };

  private _options!: ImageCropperOptions;

  constructor(options: ImageCropperInput) {
    this.options = options;
  }

  set options(options: Partial<ImageCropperOptions>) {
    const merged = { ...ImageCropperModel.DEFAULTS, ...this._options, ...options } as ImageCropperOptions;
    merged.outputWidth = merged.outputHeight * merged.aspectRatio;
    this._options = merged;
  }

  get options(): ImageCropperOptions {
    return { ...this._options };
  }

  changeOption(key: keyof ImageCropperOptions, value: any): void {
    this.options = { [key]: value };
  }
}
